import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getNavLabelKeyForPath } from '@/config/navigation';

const FALLBACK_DOCUMENT_TITLE = 'ClearRing';

/**
 * Sets `document.title` to "{screen} · ClearRing" for authenticated routes.
 * Pass `overrideTitle` when the screen name is not in nav (or is clearer inline).
 */
export function useScreenDocumentTitle(overrideTitle?: string) {
  const { pathname } = useLocation();
  const { t } = useTranslation('nav');

  useEffect(() => {
    let screen = overrideTitle;
    if (!screen) {
      const key = getNavLabelKeyForPath(pathname);
      screen = key ? t(key) : FALLBACK_DOCUMENT_TITLE;
    }
    document.title = `${screen} · ClearRing`;
    return () => {
      document.title = FALLBACK_DOCUMENT_TITLE;
    };
  }, [pathname, overrideTitle, t]);
}
